import { InputComponent } from "components/components/Component";
import { SimpleInputBaseDefinition, SimpleInputBaseComponent } from "components/input/baseInputDefinition";
import { ComponentActionHelper } from "components/events/componentActionHelper";
import { LabelElement } from "components/components/label/labelElement";
import template from "./number.hbs";
import "./number.scss";
import { NumberInputElement, initNumberInputWebComponent } from "./numberElement";

initNumberInputWebComponent();

export class NumberInput extends SimpleInputBaseComponent<NumberInputDefinition> implements InputComponent {


    public readonly componentType: string = "numberInput";

    private element: NumberInputElement;

    constructor(schema: NumberInputDefinition) {
        super(schema);
    }

    public render(): Element {
        this.renderTemplate();
        this.bindEvents();
        ComponentActionHelper.register(this);
        return this.view;
    }

    public renderTemplate(): Element {
        let objStyle: any = this.generateSytleAttribute();
        return super.renderTemplate(template, objStyle);
    }

    private generateSytleAttribute(): any {
        let objStyle: any = {};
        if ((this.definition.styleMaxWidth_ch != null) || ((this.definition.min != null || this.definition.max != null) && this.definition.labelKey == null)) {
            let maxWidth_ch = 0;
            if (this.definition.styleMaxWidth_ch != null) {
                maxWidth_ch = this.definition.styleMaxWidth_ch;
            } else {
                maxWidth_ch = this.calculateMaxWidth_ch();
            }
            objStyle.style = "max-width: calc(" + (1.1 * maxWidth_ch) + "ch + 15px);";
        }
        return objStyle;
    }

    private calculateMaxWidth_ch(): number {

        let integerNumCharsMin = 0, integerNumCharsMax = 0;
        if (this.definition.min != null) {
            integerNumCharsMin = Math.trunc(Math.abs(this.definition.min)).toString().length;
        }
        if (this.definition.max != null) {
            integerNumCharsMax = Math.trunc(Math.abs(this.definition.max)).toString().length;
        }
        let numChars = Math.max(integerNumCharsMin, integerNumCharsMax);
        if (this.definition.decimals && this.definition.decimals != 0) {
            numChars += (1 + this.definition.decimals);
        }

        //Por si es signed
        const signed = (this.definition.min == null && this.definition.max == null) || (this.definition.min == null && this.definition.max != null) || this.definition.min < 0 || this.definition.max < 0;
        if(signed) {
            numChars += 1;
        }

        return Math.ceil(numChars);
    }

    private bindEvents() {

        this.element = this.view.querySelector("s6-number-input");

        const enableKeyUpFinishedTyping = (this.definition.disableFinishedTyping !== true);

        this.genericBindEvents(this.element, enableKeyUpFinishedTyping);
    }


    public getValue(): number {
        return this.element.data;
    }

    public value(v: number): void {
        if ((v == null) || ((v as unknown) === "")) {
            this.element.data = null;
        } else {
            this.element.data = v;
        }
    }

    public setReadOnly(ro: boolean) {
        this.element.readOnly = ro;
    }

    public setRequired(required: boolean) {
        let elementLabel = this.view.querySelector("s6-input-label");
        if (elementLabel != null) {
            (elementLabel as LabelElement).required = required;
        }
    }

    public setValidationStatus(valid: boolean, message?: string) {
        this.element.valid = valid;
        this.element.validationMessage = message || null;
    }
}

export interface NumberInputDefinition extends SimpleInputBaseDefinition {
    min?: number;
    max?: number;
    decimals?: number;
    styleMaxWidth_ch?: number;
    unit: string;
    disableFinishedTyping?: boolean;
}
